import React from "react";

export const CellInfoWindow = ({ info }) => {
  return (
    <div className="map-popup">
      <span className="time">
        <strong>Name:</strong> {info.name}
      </span>
      <span className="time">
        <strong>Min. Riders:</strong> {info.minRiders}
      </span>
      <span className="time">
        <strong>Current Riders:</strong> {info.currentRidersCount}
      </span>
    </div>
  );
};
